export const Questions = [
  {
    title: 'Quem iniciou o ministério na cidade de Colossos?',
    options: [
      {
        title: 'Epafras',
        correct: true,
      },
      {
        title: 'Paulo',
        correct: false,
      },
      {
        title: 'Lucas',
        correct: false,
      },
      {
        title: 'Onésimo',
        correct: false,
      },
    ],
  },
  {
    title:
      'Qual o nome do servo de Filemom que também era cooperador de Paulo no ministério?',
    options: [
      {
        title: 'Onésimo',
        correct: true,
      },
      {
        title: 'Epafrodito',
        correct: false,
      },
      {
        title: 'Irineu',
        correct: false,
      },
      {
        title: 'Onesíforo',
        correct: false,
      },
      {
        title: 'Orígenes',
        correct: false,
      },
      {
        title: 'Tito',
        correct: false,
      },
    ],
  },
  {
    title: 'Qual dessas não é uma das chamadas "cartas do cárcere"?',
    options: [
      {
        title: 'Romanos',
        correct: true,
      },
      {
        title: 'Efésios',
        correct: false,
      },
      {
        title: 'Filemom',
        correct: false,
      },
      {
        title: 'Colossenses',
        correct: false,
      },
    ],
  },
  {
    title:
      'Em 2 Samuel Davi serviu como comandante dos Filisteus por um tempo, enquanto fugia de Saul. Qual o nome da cidade saqueada pelos amalequitas onde Davi e os valentes tiveram seus bens roubados?',
    options: [
      {
        title: 'Ziclague',
        correct: true,
      },
      {
        title: 'Zebulom',
        correct: false,
      },
      {
        title: 'Asdode',
        correct: false,
      },
      {
        title: 'Maanaim',
        correct: false,
      },
    ],
  },
  {
    title:
      'De acordo com 1 Coríntios 13, o que é mais importante do que falar línguas desconhecidas?',
    options: [
      { title: 'O amor', correct: true },
      { title: 'A fé', correct: false },
      { title: 'O dom de profecia', correct: false },
      { title: 'O conhecimento', correct: false },
    ],
  },
  {
    title:
      'Quem foi o primeiro apóstolo a ser martirizado, de acordo com Atos 12?',
    options: [
      { title: 'Pedro', correct: false },
      { title: 'Tiago', correct: true },
      { title: 'João', correct: false },
      { title: 'André', correct: false },
      { title: 'Filipe', correct: false },
      { title: 'Tomé', correct: false },
      { title: 'Mateus', correct: false },
      { title: 'Bartolomeu', correct: false },
    ],
  },
  {
    title:
      'O que Jesus disse ser o maior mandamento, de acordo com Marcos 12 e Mateus 22?',
    options: [
      { title: 'Ame o seu próximo como a si mesmo', correct: false },
      { title: 'Não matarás', correct: false },
      { title: 'Não cometerás adultério', correct: false },
      {
        title: 'Ame o Senhor, teu Deus, com todo o teu coração, alma e mente',
        correct: true,
      },
      { title: 'Honra teu pai e tua mãe', correct: false },
      { title: 'Não roubarás', correct: false },
      {
        title: 'Não levantarás falsos testemunhos contra o teu próximo',
        correct: false,
      },
      { title: 'Não cobiçarás a mulher do teu próximo', correct: false },
    ],
  },
  {
    title:
      'De acordo com o Evangelho de João, qual era o nome do discípulo que Jesus amava?',
    options: [
      { title: 'Tiago', correct: false },
      { title: 'João', correct: true },
      { title: 'Pedro', correct: false },
      { title: 'André', correct: false },
      { title: 'Filipe', correct: false },
      { title: 'Tomé', correct: false },
      { title: 'Mateus', correct: false },
      { title: 'Bartolomeu', correct: false },
    ],
  },
  {
    title:
      'De acordo com Atos 4, qual foi o nome do sumo sacerdote que presidiu o julgamento de Pedro e João?',
    options: [
      { title: 'Anás', correct: false },
      { title: 'Caifás', correct: true },
      { title: 'Gamaliel', correct: false },
      { title: 'Saulo', correct: false },
      { title: 'Nicolau', correct: false },
      { title: 'Lázaro', correct: false },
      { title: 'Eusebio', correct: false },
      { title: 'Timóteo', correct: false },
    ],
  },
  {
    title:
      'Quem foi o apóstolo que foi preso e lançado na prisão por pregar o Evangelho em Jerusalém, mas foi libertado por um anjo e continuou pregando em outros lugares, segundo o livro de Atos?',
    options: [
      {
        title: 'Pedro',
        correct: true,
      },
      {
        title: 'Paulo',
        correct: false,
      },
      {
        title: 'Silas',
        correct: false,
      },
      {
        title: 'Tiago',
        correct: false,
      },
      {
        title: 'Estêvão',
        correct: false,
      },
      {
        title: 'Ananias',
        correct: false,
      },
    ],
  },
  {
    title:
      'Quem foi o primeiro cristão gentio a ser batizado, segundo o relato do livro de Atos?',
    options: [
      {
        title: 'Cornélio',
        correct: true,
      },
      {
        title: 'Timóteo',
        correct: false,
      },
      {
        title: 'Eunico',
        correct: false,
      },
      {
        title: 'Tito',
        correct: false,
      },
      {
        title: 'Lídia',
        correct: false,
      },
      {
        title: 'Sílas',
        correct: false,
      },
    ],
  },
  {
    title:
      'Qual foi a primeira cidade da Europa a ser evangelizada, segundo o relato do livro de Atos?',
    options: [
      {
        title: 'Tessalônica',
        correct: false,
      },
      {
        title: 'Corinto',
        correct: false,
      },
      {
        title: 'Atenas',
        correct: false,
      },
      {
        title: 'Fenícia',
        correct: false,
      },
      {
        title: 'Filadélfia',
        correct: false,
      },
      {
        title: 'Filipos',
        correct: true,
      },
    ],
  },
  {
    title: 'Em quantas cidades diferentes Paulo esteve preso no livro de Atos?',
    options: [
      {
        title: '1',
        correct: false,
      },
      {
        title: '2',
        correct: false,
      },
      {
        title: '3',
        correct: false,
      },
      {
        title: '4',
        correct: true,
      },
      {
        title: '5',
        correct: false,
      },
      {
        title: '6',
        correct: false,
      },
    ],
  },
  {
    title:
      'Quantos registros existem no livro de Atos de discursos feitos por Pedro diante do povo ou das autoridades judaicas?',
    options: [
      {
        title: '1',
        correct: false,
      },
      {
        title: '2',
        correct: false,
      },
      {
        title: '3',
        correct: false,
      },
      {
        title: '4',
        correct: true,
      },
      {
        title: '5',
        correct: false,
      },
      {
        title: '6',
        correct: false,
      },
    ],
  },
  {
    title: 'Qual era a cidade dos irmãos Lázaro, Marta e Maria?',
    options: [
      {
        title: 'Jerusalém',
        correct: false,
      },
      {
        title: 'Betsaida',
        correct: false,
      },
      {
        title: 'Belém',
        correct: false,
      },
      {
        title: 'Nazaré',
        correct: false,
      },
      {
        title: 'Betânia',
        correct: true,
      },
      {
        title: 'Tiro',
        correct: false,
      },
      {
        title: 'Sido',
        correct: false,
      },
      {
        title: 'Galileia',
        correct: false,
      },
    ],
  },
  {
    title: 'Qual desses não era um dos doze discípulos de Jesus?',
    options: [
      {
        title: 'Mateus',
        correct: false,
      },
      {
        title: 'Tiago',
        correct: false,
      },
      {
        title: 'João',
        correct: false,
      },
      {
        title: 'Pedro',
        correct: false,
      },
      {
        title: 'André',
        correct: false,
      },
      {
        title: 'Filipe',
        correct: false,
      },
      {
        title: 'Bartolomeu',
        correct: false,
      },
      {
        title: 'Tadeu',
        correct: false,
      },
      {
        title: 'Simão',
        correct: false,
      },
      {
        title: 'Judas',
        correct: false,
      },
      {
        title: 'Natanael',
        correct: true,
      },
    ],
  },
  {
    title:
      'Em que cidade Paulo foi preso pela segunda vez por causa do evangelho?',
    options: [
      {
        title: 'Corinto',
        correct: false,
      },
      {
        title: 'Atenas',
        correct: false,
      },
      {
        title: 'Roma',
        correct: false,
      },
      {
        title: 'Eféso',
        correct: false,
      },
      {
        title: 'Jerusalém',
        correct: true,
      },
      {
        title: 'Salamina',
        correct: false,
      },
      {
        title: 'Tarso',
        correct: false,
      },
      {
        title: 'Antioquia',
        correct: false,
      },
    ],
  },
  {
    title: 'Qual o rei que ouviu a defesa de Paulo em Atos 26?',
    options: [
      {
        title: 'Agripa',
        correct: true,
      },
      {
        title: 'Sérgio Paulo',
        correct: false,
      },
      {
        title: 'Herodes',
        correct: false,
      },
      {
        title: 'César',
        correct: false,
      },
      {
        title: 'Pilatos',
        correct: false,
      },
      {
        title: 'Quirino',
        correct: false,
      },
      {
        title: 'Festo',
        correct: false,
      },
      {
        title: 'Augusto',
        correct: false,
      },
    ],
  },
  {
    title: 'Quantos profetas e mestres haviam na igreja em Antioquia?',
    options: [
      {
        title: '2',
        correct: false,
      },
      {
        title: '3',
        correct: false,
      },
      {
        title: '4',
        correct: false,
      },
      {
        title: '5',
        correct: true,
      },
      {
        title: '6',
        correct: false,
      },
      {
        title: '7',
        correct: false,
      },
      {
        title: '8',
        correct: false,
      },
      {
        title: '9',
        correct: false,
      },
    ],
  },
  {
    title: 'Qual desses era um dos líderes da igreja em Antioquia?',
    options: [
      {
        title: 'Lúcio',
        correct: true,
      },
      {
        title: 'Hermas',
        correct: false,
      },
      {
        title: 'Andrônico',
        correct: false,
      },
      {
        title: 'Ampliato',
        correct: false,
      },
      {
        title: 'Urbano',
        correct: false,
      },
      {
        title: 'Nicanor',
        correct: false,
      },
      {
        title: 'Parmênas',
        correct: false,
      },
      {
        title: 'Nicolau',
        correct: false,
      },
    ],
  },
  {
    title: 'Qual desses era um dos líderes da igreja em Antioquia?',
    options: [
      {
        title: 'Manaém',
        correct: true,
      },
      {
        title: 'Hermas',
        correct: false,
      },
      {
        title: 'Andrônico',
        correct: false,
      },
      {
        title: 'Ampliato',
        correct: false,
      },
      {
        title: 'Urbano',
        correct: false,
      },
      {
        title: 'Nicanor',
        correct: false,
      },
      {
        title: 'Parmênas',
        correct: false,
      },
      {
        title: 'Nicolau',
        correct: false,
      },
    ],
  },
  {
    title: 'Qual desses é um dos diáconos listados em Atos 4?',
    options: [
      {
        title: 'Nicanor',
        correct: true,
      },
      {
        title: 'Timóteo',
        correct: false,
      },
      {
        title: 'Barnabé',
        correct: false,
      },
      {
        title: 'Manaém',
        correct: false,
      },
      {
        title: 'Andrônico',
        correct: false,
      },
      {
        title: 'Junias',
        correct: false,
      },
      {
        title: 'Amíntas',
        correct: false,
      },
      {
        title: 'Rufo',
        correct: false,
      },
    ],
  },
  {
    title:
      'Qual destas não é uma das características do amor em 1 Coríntios 13?',
    options: [
      {
        title: 'É benigno',
        correct: false,
      },
      {
        title: 'É paciente',
        correct: false,
      },
      {
        title: 'É doce',
        correct: true,
      },
      {
        title: 'Não é incoveniente',
        correct: false,
      },
      {
        title: 'Não se exaspera',
        correct: false,
      },
      {
        title: 'Não se ressente do mal',
        correct: false,
      },
      {
        title: 'Jamais acaba',
        correct: false,
      },
      {
        title: 'É temperante',
        correct: false,
      },
      {
        title: 'Não procura seus interesses',
        correct: false,
      },
    ],
  },
  {
    title: 'Qual desses não é um fruto do Espírito, de acordo com Gálatas 5?',
    options: [
      {
        title: 'Alegria',
        correct: false,
      },
      {
        title: 'Paz',
        correct: false,
      },
      {
        title: 'Longanimidade',
        correct: false,
      },
      {
        title: 'Bondade',
        correct: false,
      },
      {
        title: 'Benignidade',
        correct: false,
      },
      {
        title: 'Fidelidade',
        correct: false,
      },
      {
        title: 'Mansidão',
        correct: false,
      },
      {
        title: 'Domínio próprio',
        correct: false,
      },
      {
        title: 'Verdade',
        correct: true,
      },
    ],
  },
  {
    title:
      'Qual grupo de discípulos teve suas viúvas esquecidas na distribuição diária quando a Igreja decidiu instituir diáconos para esse serviço?',
    options: [
      {
        title: 'Os Helenistas',
        correct: true,
      },
      {
        title: 'Os Efésios',
        correct: false,
      },
      {
        title: 'Os Sidônios',
        correct: false,
      },
      {
        title: 'Os Essênios',
        correct: false,
      },
      {
        title: 'Os Elamitas',
        correct: false,
      },
      {
        title: 'Os Cretenses',
        correct: false,
      },
      {
        title: 'Os Arábios',
        correct: false,
      },
      {
        title: 'Os Persas',
        correct: false,
      },
    ],
  },
]
